import { isEmpty } from 'lodash';
import receiptline from 'receiptline';
import IOrder from '~/interfaces/IOrder';
import getAddressFormatted from './getAddressFormatted';
import getCurrencyFormatted from './getCurrencyFormatted';
import { PAYMENT_METHODS } from './getEnums';

interface ISettingsCompany {
  print_description: string;
  waiter_name?: string;
  percentage_optional?: boolean;
  print_payment_value?: boolean;
  print_products?: boolean;
}

export function getPrintEscPos(
  data: IOrder,
  {
    print_description,
    waiter_name,
    percentage_optional,
    print_payment_value,
    print_products,
  }: ISettingsCompany,
) {
  const client = `"${data.name}`;
  let header = `"${data.name}
${data.whatsapp}`;

  if (data.table?.uid) {
    header = `"MESA ${data.table.name}`;
  }

  let products = '';
  let items_products = '';

  data.products.forEach(item => {
    const value = getCurrencyFormatted(parseFloat(item.value));
    const total = getCurrencyFormatted(parseFloat(item.value) * item.quantity);

    let complement_txt = '';
    let complement_txt2 = '';
    let obs_txt = '';

    // Adicionando observação do produto
    if (item.observations) {
      obs_txt = `\n|Obs: ${item.observations}`;
    }

    (item.complements || []).forEach(complement => {
      complement_txt += `
|${complement.quantity}x ${complement.item.name}`;
      complement_txt2 += `
|- ${complement.item.name}`;
    });

    items_products = `${items_products}
|${item.quantity}x ${item.name.toUpperCase()}${complement_txt2}${obs_txt}`;

    products = `${products}
|"${item.name.toUpperCase()}${complement_txt}${obs_txt}
|${value} |${item.quantity}x| ${total}
`;
  });

  products = products.replace('\n', '');
  items_products = items_products.replace('\n', '');

  // data.total já inclui o couvert artístico
  // Calcular o subtotal (total - couvert artístico)
  const subtotalValue = parseFloat(`${data.subtotal}`);
  const subtotalFmt = getCurrencyFormatted(subtotalValue);

  // Calcular percentage_optional sobre o subtotal (se houver)
  let percentageValue = 0;
  if (percentage_optional) {
    percentageValue = (subtotalValue * 10) / 100;
  }

  // Calcular o total final: subtotal + percentage_optional + couvert artístico
  const finalTotal =
    subtotalValue + percentageValue + (data.artisticCouvertTotal || 0);

  const totalValueFmt = getCurrencyFormatted(finalTotal);

  let payment = '';

  if (data.paymentMethod) {
    payment = `|${PAYMENT_METHODS[data.paymentMethod]} | ${totalValueFmt}`;
  }

  if (data.orderPayments && data.orderPayments.length > 0) {
    data.orderPayments.forEach(item => {
      payment += `|${PAYMENT_METHODS[item.payment_method_id]} | ${
        item.value_formatted
      }`;
    });
  }

  // Adicionando lógica do troco
  if (data.thing) {
    const thing_value = getCurrencyFormatted(
      parseFloat(data.thing) - data.total,
    );
    payment += `\n|RECEBER | ${getCurrencyFormatted(parseFloat(data.thing))}`;
    payment += `\n|TROCO | ${thing_value}`;
  }

  let address = '';

  if (!isEmpty(data.address) && data.address.road) {
    address = `${getAddressFormatted(data.address)}`;
  }

  if (!isEmpty(data.address) && !data.address.road) {
    address = `${data.address}`;
  }

  if (isEmpty(data.address)) {
    address = `${data.table?.uid ? 'CONSUMO NO LOCAL' : 'RETIRADA LOCAL'}`;
  }

  let orderType = 'DELIVERY';

  if (data.table?.uid) {
    orderType = `MESA ${data.table.name}`;
  } else if (isEmpty(data.address)) {
    orderType = `RETIRADA LOCAL`;
  }

  let totais = `|"TOTAIS
|SUB-TOTAL | ${subtotalFmt}`;

  if (data.shippingCost > 0) {
    totais += `\n|ENTREGA | ${data.shippingCost_formatted}`;
  }

  if (data.artisticCouvertTotal && data.artisticCouvertTotal > 0) {
    totais += `\n|COUVERT ARTISTICO | ${getCurrencyFormatted(
      data.artisticCouvertTotal,
    )}`;
  }

  if (percentage_optional && percentageValue > 0) {
    totais += `\n|OPCIONAL | ${getCurrencyFormatted(percentageValue)}`;
  }

  totais += `\n|TOTAL | ${totalValueFmt}`;

  let doc = `"${data.company_name.toUpperCase()}

${data.created_at_formatted}

${header}

"CUPOM NÃO FISCAL

${products}

${totais}

|"PAGAMENTO
${payment}

|"ENTREGA
|${address}

"CÓDIGO DO PEDIDO: ${data.code}
TECNOLOGIA
WWW.TEM-PEDIDO.WEB.APP


=


|"CLIENTE: ${client}

|${orderType}

|"ITENS DO PEDIDO
${items_products}


`;

  doc = doc.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  console.log(doc);

  const printer = {
    cpl: 48,
    encoding: 'cp860',
    upsideDown: false,
    gamma: 1.8,
    command: 'escpos',
    spacing: true,
  } as receiptline.Printer;

  const command = receiptline.transform(doc, printer);

  return command;
}
